module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABAUlEQVRIib2WQW7CMBBFn60egK4Qy+4K6iU4BifIRbhLDxD2XAKVXZeIHVlm91nY0KjNxMHFeZIVyfH8iSeeGTtJDLAENsAa+ABmcb4BDsAe+ASOpoKkvvEuqdZ46mjzR6tPvJLUPiB+o422gw62GcK/2VoOqieI37jvpBvznLBYtFHz7iD1Q98kzeJzLLUknKQl8DV0VgHXPXiJtV1WPp7zUmw8IYlKsXaSLvxkqEVuiBonDdeKfzrg5ZHFkVdj7rtvcU6ILPp21nhCVUwxT7xfGPMHTyi5Kc6EL7TGybDbj020XFae0Cx2BcR3wHGyYle8XE/ScCZpmU9v+k6Fry1X/MkH4kndDGoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/recordInformation/15.png
// module id = 1681
// module chunks = 2